import { render, staticRenderFns } from "./Donaties.vue?vue&type=template&id=7071a438&scoped=true&"
import script from "./Donaties.vue?vue&type=script&lang=js&"
export * from "./Donaties.vue?vue&type=script&lang=js&"
import style0 from "./Donaties.vue?vue&type=style&index=0&id=7071a438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071a438",
  null
  
)

export default component.exports